import { useEffect } from 'react';

import { trackContentLinkClick } from '../utils/brochureTracking';

// Attaches delegated <a>-click tracking to a container ref, for
// dangerouslySetInnerHTML / mixed content (About sections + captions +
// resources, the Amenities & Services blurb). Uses a native click listener
// rather than a JSX onClick, so the static container carries no interaction
// a11y footprint — the real interactive elements are the nested links. Inert
// without `tracking`.
//
// @param {React.RefObject} ref - Container element ref.
// @param {Object} tracking - Brochure tracking creds ({ endpoint, token, identity }).
// @param {number} [contentNid] - Node the content belongs to, when applicable.
const useContentLinkTracking = (ref, tracking, contentNid) => {
  useEffect(() => {
    const el = ref.current;
    if (!el || !tracking) return undefined;

    const handler = (event) => trackContentLinkClick(event, tracking, contentNid);
    el.addEventListener('click', handler);
    return () => el.removeEventListener('click', handler);
  }, [ref, tracking, contentNid]);
};

export default useContentLinkTracking;
